export default __webpack_public_path__ + "static/media/flame.7afe74b6.svg";